import { logout } from "@/features/auth/actions/auth-actions"
import { clearUserSessionStores } from "@/lib/store-utils"
import { authStore } from "@/store/auth"
import axios from "axios"

const baseURL = import.meta.env.VITE_API_URL || "https://api.speeke.ai/api/v1"

export const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: {
    indexes: null,
  },
})

// Interceptor para adicionar token de autenticação
api.interceptors.request.use(
  config => {
    const token = authStore.getState().token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

// Interceptor para tratamento de erros
api.interceptors.response.use(
  response => response,
  error => {
    // Lidar com erros de autenticação
    if (error.response?.status === 401) {
      const state = authStore.getState()
      if (state.isImpersonating) {
        // Token impersonado expirou -> restaurar sessão admin
        clearUserSessionStores()
        authStore.setState({
          token: state.originalAdminToken,
          refreshToken: state.originalAdminRefreshToken,
          tokenType: "bearer",
          user: state.originalAdminUser,
          isAuthenticated: true,
          isImpersonating: false,
          impersonatorId: null,
          originalAdminToken: null,
          originalAdminRefreshToken: null,
          originalAdminUser: null,
        })
        window.location.href = "/admin/users"
      } else {
        logout()
        window.dispatchEvent(new CustomEvent("auth:logout"))
      }
      // 401 already handled (logout + redirect) - suppress error propagation
      return new Promise(() => {})
    }
    return Promise.reject(error)
  }
)
